module.exports = __webpack_public_path__ + "img/icon_atm_02.629d70c6.png";